const PICKUP_ASSIGNMENT_TYPE = {
  assignAll: 'Assign all',
  assignSelected: 'Assign selected',
  assignIndividual: 'Assign individual'
};

const RECOMMENDATION_INFO = {
  ASSIGN_ALL: {
    title: 'Accept All Driver Recommendations',
    description: 'Are you sure you want to accept driver recommendations for all pickups?',
    subDescription: 'No Recommendation Available!'
  },
  ASSIGN_SELECTED: {
    title: 'Accept Selected Driver Recommendations',
    description: 'Are you sure you want to accept driver recommendations for selected pickups?',
    subDescription: 'Please select at least one pickup with a recommended driver.'
  }
};
const recommendationMenuOptions = [PICKUP_ASSIGNMENT_TYPE.assignAll];

const RECOMMENDATION_MESSAGE = {
  SUCCESS: {
    AUTO_REFRESH_RECOMMENDATION: "Recommendations refreshed successfully.",
    NO_RECOMMENDATION: "No recommendations available at the moment.",
  },
  FAILED: {
    AUTO_REFRESH_RECOMMENDATION: "Failed to automatically update pickup recommendations.",
    MANUAL_REFRESH: "Failed to manually refresh recommendations.",
    ENABLE_ASSIGN_RECOMMENDATION: "Failed to enable assigned pickup recommendations.",
    UNKNOWN_ERROR: "An unknown error has occurred. Please retry by using the manual recommendation refresh button.",
  }
}

const RECOMMENDATION_HEADER_NAME = "Driver Recommendation";
const DRIVER_RECOMMENDATION_COL_ID = "driverRecommendation";

const RECOMMENDATION_EXPIRY_TIME_IN_MINUTES = 5;

export {
  recommendationMenuOptions,
  PICKUP_ASSIGNMENT_TYPE,
  RECOMMENDATION_INFO,
  RECOMMENDATION_MESSAGE,
  RECOMMENDATION_EXPIRY_TIME_IN_MINUTES,
  RECOMMENDATION_HEADER_NAME,
  DRIVER_RECOMMENDATION_COL_ID,
};
